import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Lista de aplicații pe care le poate purta un tichet.
 *
 * Sursa e una singură: registrul de proiecte al workspace-ului, calculat pe
 * server (`GET /api/ticket-apps`). Frontendul nu-și ține o copie — dacă
 * cineva adaugă un proiect în Setări, meniul îl are fără să atingem codul.
 *
 * `unknown` sunt valorile pe care le poartă tichete vechi și care nu mai sunt
 * în registru. Vin de la server ca să le putem arăta marcate, nu ca să le
 * rescriem.
 */
export default function useFeedbackApps(workspaceId) {
  const [state, setState] = useState({ apps: [], unknown: [], allApps: "", loaded: false });

  useEffect(() => {
    let active = true;
    if (!workspaceId) return undefined;
    api.get("/ticket-apps", { params: { workspace_id: workspaceId } })
      .then(({ data }) => {
        if (!active) return;
        setState({
          apps: data?.apps || [], unknown: data?.unknown || [],
          allApps: data?.all_apps || "", loaded: true,
        });
      })
      .catch(() => { if (active) setState((s) => ({ ...s, loaded: true })); });
    return () => { active = false; };
  }, [workspaceId]);

  return state;
}
